import React, { useEffect, useState } from "react";
import NbaOptimizer from "./NbaOptimizer";
import NbaLateSwap from "./NbaLateSwap";

const useStickyState = (key, init) => {
  const [v, setV] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw != null ? JSON.parse(raw) : init;
    } catch {
      return init;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(v));
    } catch {}
  }, [key, v]);

  return [v, setV];
};

export default function NbaOptimizerPage() {
  const [tab, setTab] = useStickyState("nba.activeTab", "optimizer");

  return tab === "optimizer" ? (
    <NbaOptimizer activeTab={tab} setActiveTab={setTab} />
  ) : (
    <NbaLateSwap activeTab={tab} setActiveTab={setTab} />
  );
}